import { Link } from "react-router-dom";
import { usePageMeta } from "@/lib/seo";
import { ArrowRight } from "lucide-react";
import { PRODUCTS } from "@/lib/products";
import { ProductLogo } from "@/components/ProductLogo";


export default function ProductsPage() {
  usePageMeta("Products", "Shop management, digital vehicle inspections, customer portal, video conferencing and Web Advisor AI — everything an auto repair shop needs.");
  return (
    <div className="min-h-screen bg-white pt-24 pb-20 px-6 md:px-12 lg:px-24" data-testid="products-page">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <p className="text-xs tracking-[0.2em] uppercase font-bold text-blue-600 mb-3">ShopAdvisor Ecosystem</p>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl tracking-tighter font-black text-slate-900 mb-4">Our Product Suite</h1>
          <p className="text-lg text-slate-500 max-w-2xl mx-auto">Eight powerful modules designed to run every aspect of your automotive or service business.</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {PRODUCTS.map((p) => (
            <div key={p.id} className="bg-white border border-slate-200 rounded-xl overflow-hidden group hover:border-blue-400 hover:shadow-lg transition-all duration-300 hover:-translate-y-1" data-testid={`product-card-${p.id}`}>
              <div className="h-56 bg-slate-50 flex items-center justify-center p-6 border-b border-slate-100 overflow-hidden">
                <ProductLogo product={p} />
              </div>
              <div className="p-6">
                <p className="text-xs tracking-wider uppercase text-blue-600 font-bold mb-1">{p.tagline}</p>
                <h3 className="text-xl font-semibold text-slate-900 mb-2">{p.name}</h3>
                <p className="text-slate-500 text-sm mb-4 leading-relaxed">{p.desc}</p>
                <div className="flex flex-wrap gap-2 mb-5">
                  {p.features.map((f, j) => (
                    <span key={j} className="text-xs bg-blue-50 text-blue-600 px-2.5 py-1 rounded-full border border-blue-100">{f}</span>
                  ))}
                </div>
                <Link to={`/demo?module=${p.id}`} className="inline-flex items-center gap-2 text-blue-600 hover:text-blue-500 text-sm font-medium transition-colors" data-testid={`product-demo-${p.id}`}>
                  View Demo <ArrowRight className="w-4 h-4" />
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
